import type { AnatomyPart } from './grass-atlas-experience'

export const KENTUCKY_BLUEGRASS_MODEL_SOURCES = [
  {
    label: 'Penn State Turfgrass Science',
    href: 'https://extension.psu.edu/the-cool-season-turfgrasses-identification',
  },
  {
    label: 'University of Minnesota Extension',
    href: 'https://extension.umn.edu/forage-variety-selection/identifying-common-cool-season-perennial-pasture-grasses',
  },
] as const

export const KENTUCKY_BLUEGRASS_MODEL_CUES: Record<AnatomyPart, string> = {
  'blade-tip': 'Keeled, boat-shaped tip with the two sides meeting like the prow of a canoe.',
  blade: 'Narrow folded blade with one dominant midvein, paired grooves, and a dull underside.',
  collar: 'Short membranous ligule. Auricles are absent, so nothing clasps the stem here.',
  node: 'Split, hairless leaf sheath around a compact upright tiller.',
  runner: 'Short underground rhizomes, not aboveground stolons, connect new shoots.',
  roots: 'Fine fibrous roots descend from the crown and from rhizome nodes.',
  seedhead: 'Open, branched panicle rather than the flattened spike of ryegrasses.',
}

export const KENTUCKY_BLUEGRASS_PART_LABELS: Partial<Record<AnatomyPart, string>> = {
  runner: 'Rhizome',
}
